import { createFileRoute } from "@tanstack/react-router";
import { EventsContent } from "@/features/study-group-events/components/EventsContent";

export const Route = createFileRoute("/study-group/$study-group-id/events")({
  component: EventsContent,
});
